import type { NoContext } from '~/services/api/contracts/NoContext'
import { PartnerUserInvitationShowQuerySchema } from '~/services/api/generated'

// InvitationLookupRequest::rules
export const PartnerUserInvitationShow = (_context: NoContext = {}) =>
  PartnerUserInvitationShowQuerySchema
